<div [formGroup]="formGroup">
    <kendo-datepicker  formControlName="date" (valueChange)="fixValue($event)">
    </kendo-datepicker>

    <spv2-input-error-display [show]="formGroup.get('date').errors" [text]="'\'Valid From\' date cannot be greater than \'Valid Until\'.'">
    </spv2-input-error-display>
</div>
